import { render } from "./popup.vue?vue&type=template&id=6ededb44&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=6ededb44&lang=css"
import "./popup.vue?vue&type=style&index=1&id=6ededb44&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ededb44"]])

export default __exports__